module.exports = __webpack_public_path__ + "pc/img/about-global-person03.e786bbc9.png";